import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    containerSticky: InjectableCss;
    logoWrapper: InjectableCss;
    searchWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    alignMiddle: HiddenProps;
    stickProductsWrapper?: InjectableCss;
    stickProductsWrapperVisible?: InjectableCss;
    showHamburger?: InjectableCss;
    phoneNumber?: InjectableCss;
    phoneNumberWrapper?: InjectableCss;
    scrollFixed?: InjectableCss;
    searchWrapperSticky?: InjectableCss;
    phoneNumberWrapperSticky?: InjectableCss;
    searchMenuWrapperSticky?: InjectableCss;
    logoWrapperSticky?: InjectableCss;
    mobileCartWrapper?: InjectableCss;
    mobileCartWrapperSticky?: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            max-width: 1440px;
            margin: 0 auto;
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    containerSticky: {
        css: css`
            display: flex;
            justify-content: space-between;
            max-width: 1440px;
            margin: 0 auto;
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            padding: 10px 0 3px;
            margin: 0 0 0 15px;
            width: 25%;
            display: flex;
            align-items: center;
            a {
                width: 100%;
                span {
                    width: 100%;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            a {
                                span {
                                    display: flex;
                                    justify-content: center;
                                }
                            }
                            width: 100%;
                            margin: 0;
                        `,
                        css`
                            a {
                                span {
                                    display: flex;
                                    justify-content: center;
                                }
                            }
                            width: 100%;
                            margin: 0;
                        `,
                        css`
                            a {
                                span {
                                    display: flex;
                                    justify-content: center;
                                }
                            }
                            width: 100%;
                            margin: 0;
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: auto;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 50px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchWrapper: {
        css: css`
            width: 43%;
            margin-left: 3%;
            display: flex;
            justify-content: center;
            align-items: center;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 94%;
                        `,
                        css`
                            width: 94%;
                        `,
                        css`
                            width: 94%;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            > div[class^="HiddenStyle"] {
                width: 100%;
                > div[class^="Wrapper"] {
                    border: ${getColor("text.accent")} 1px solid;
                    border-radius: 20px;
                    height: 40px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    border-color: #e2e2e2;
                                    background: #f8f8f8;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        );
                    }}
                    input, button {
                        border-radius: 20px !important;
                    }
                    [class^="FormFieldStyle"] {
                        width: 100%;
                        input {
                            background: #f8f8f8;
                            ::placeholder {
                                font-size: 12px;
                                opacity: 1; /* Firefox */
                            }
                            :-ms-input-placeholder {
                                /* Internet Explorer 10-11 */
                                font-size: 12px;
                            }
                            ::-ms-input-placeholder {
                                /* Microsoft Edge */
                                font-size: 12px;
                            }
                        }
                        & + div[id^="headerSearch"] {
                            margin-top: 2px;
                            min-width: 40%;
                            input,
                            button {
                                border-radius: 0 !important;
                            }
                            ${({ theme }) => {
                                return breakpointMediaQueries(
                                    theme,
                                    [
                                        null,
                                        null,
                                        null,
                                        css`
                                            right: 250.719px !important;
                                            left: 15px;
                                        `,
                                        null,
                                    ],
                                    "max",
                                );
                            }}
                    input[type="text"] {
                        border: none;
                        height: 38px;
                        font-size: 12px;
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        font-size: 16px;
                                    `,
                                    css`
                                        font-size: 16px;
                                    `,
                                    css`
                                        font-size: 16px;
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            );
                        }}
                        & + button {
                            background: ${getColor("text.accent")};
                            height: 40px;
                            width: 40px;
                            right: -1px;
                            top: -1px;
                            ${({ theme }) => {
                                return breakpointMediaQueries(
                                    theme,
                                    [
                                        css`
                                            background: none;
                                        `,
                                        css`
                                            background: none;
                                        `,
                                        css`
                                            background: none;
                                        `,
                                        null,
                                        null,
                                    ],
                                    "max",
                                );
                            }}
                            svg {
                                color: #fff;
                                width: 24px;
                                height: 24px;
                                ${({ theme }) => {
                                    return breakpointMediaQueries(
                                        theme,
                                        [
                                            null,
                                            null,
                                            css`
                                                color: #353432;
                                            `,
                                            null,
                                            null,
                                        ],
                                        "max",
                                    );
                                }}
                            }
                        }
                    }
                    div[class^="PopoverStyle"] {
                        a,
                        button,
                        span {
                            color: ${getColor("text.main")};
                            font-size: 13px;
                        }
                        [class^="StyledButton"] {
                            font-weight: 600;
                        }
                    }
                }
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            text-align: right;
            padding: 10px 15px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            > div {
                padding-top: 15px;
                > div {
                    display: flex;
                    flex-direction: row;
                    align-items: start;
                    position: relative;
                }
                button,
                a,
                .trigger {
                    display: flex;
                    flex-direction: column;
                    margin: 0 15px;
                    height: auto;
                    position: relative;
                    span[class^="IconWrapper"],
                    span[class^="LazyImageStyle"] {
                        background: ${getColor("text.accent")};
                        padding: 10px;
                        border-radius: 20px;
                        width: 40px;
                        height: 40px;
                        margin: 0;
                        svg {
                            color: #fff;
                            width: 20px;
                            height: 20px;
                        }
                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }
                    p {
                        font-weight: normal;
                        font-size: 12px;
                        margin: 0;
                        &[transform="capitalize"] {
                            position: absolute;
                            top: 40px;
                        }
                    }
                    &:hover {
                        span,
                        p {
                            text-decoration: underline;
                        }
                    }
                }
            }
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    alignMiddle: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    stickProductsWrapper: {
        css: css`
            display: none;
        `,
    },
    stickProductsWrapperVisible: {
        css: css`
            margin-left: 2%;
            display: flex;
            align-items: center;
            line-height: 56px;
            [class^="HiddenStyle"] {
                [class^="HiddenStyle"] {
                    padding: 0 10px 0 20px;
                }
            }
            [class^="sc"] {
                padding: 0;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            [class^="HiddenStyle"] {
                                [class^="HiddenStyle"] {
                                    &:last-of-type {
                                        display: none;
                                    }
                                }
                            }
                        `,
                        css`
                            [class^="HiddenStyle"] {
                                [class^="HiddenStyle"] {
                                    &:last-of-type {
                                        display: none;
                                    }
                                }
                            }
                        `,
                        css`
                            [class^="HiddenStyle"] {
                                [class^="HiddenStyle"] {
                                    &:last-of-type {
                                        display: none;
                                    }
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            button[class^="StyledButton"] {
                margin: 1px 0;
                + [class^="sc"] {
                    max-height: calc(100vh - 70px) !important;
                }

                p {
                    color: ${getColor("text.accent")};
                    display: flex;
                    align-items: center;
                    border: 1px solid #ccc;
                    border-radius: 20px;
                    height: 40px;
                    padding: 2px 10px 0 15px;
                    font-size: 16px;
                    font-family: "HelveticaCondensed";
                    svg {
                        color: ${getColor("text.accent")};
                    }
                }
                & + div {
                    top: 65px;
                    border-top: 2px solid ${getColor("primary")};
                }
                &:hover {
                    p {
                        color: ${getColor("text.accent")} !important;
                        text-decoration: underline;
                    }
                }
            }
            // [data-test-selector="expandMobileMenu"] {
            //     top: 5px;
            //     left: 5px;
            // }
        `,
    },
    showHamburger: {
        css: css`
            display: flex;
            align-items: center;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            [class^="HiddenStyle"] {
                                [class^="HiddenStyle"] {
                                    &:last-of-type {
                                        display: none;
                                    }
                                }
                            }
                        `,
                        css`
                            [class^="HiddenStyle"] {
                                [class^="HiddenStyle"] {
                                    &:last-of-type {
                                        display: none;
                                    }
                                }
                            }
                        `,
                        css`
                            [class^="HiddenStyle"] {
                                [class^="HiddenStyle"] {
                                    &:last-of-type {
                                        display: none;
                                    }
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    phoneNumber: {
        css: css`
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                            display: none;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    phoneNumberWrapper: {
        css: css`
            display: flex;
            align-items: center;
            width: 14%;
            margin-left: 2%;
            p.phoneNumber {
                border: 1px solid #ccc;
                border-radius: 20px;
                height: 40px;
                display: flex;
                align-items: center;
                width: 100%;
                justify-content: center;
                a {
                    font-size: 13px;
                    height: auto;
                    span[class^="TypographyStyle"] {
                        display: flex;
                        align-items: flex-start;
                        color: ${getColor("text.accent")};
                        span {
                            height: 18px;
                            span[class^="LazyImageStyle"] {
                                img {
                                    width: 18px;
                                    height: 18px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    scrollFixed: {
        css: css`
            display: block;
            z-index: 100;
            position: fixed;
            top: 0;
            left: 0;
            background: #fff;
            width: 100%;
            height: auto;
            border-bottom: 5px solid ${getColor("primary")};
            * {
                transition: all 0.4s ease;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: block;
                            z-index: 100;
                            position: static !important;
                            top: 0;
                            left: 0;
                            background: #fff;
                            width: 100%;
                            height: auto;
                            border-bottom: 5px solid ${getColor("primary")};
                            * {
                                transition: all 0.4s ease;
                            }
                        `,
                        css`
                            display: block;
                            z-index: 100;
                            position: static !important;
                            top: 0;
                            left: 0;
                            background: #fff;
                            width: 100%;
                            height: auto;
                            border-bottom: 5px solid ${getColor("primary")};
                            * {
                                transition: all 0.4s ease;
                            }
                        `,
                        css`
                            display: block;
                            z-index: 100;
                            position: static !important;
                            top: 0;
                            left: 0;
                            background: #fff;
                            width: 100%;
                            height: auto;
                            border-bottom: 5px solid ${getColor("primary")};
                            * {
                                transition: all 0.4s ease;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    logoWrapperSticky: {
        css: css`
            text-align: left;
            padding: 2px 0 0 0;
            margin: 0 0 0 15px;
            width: 25%;
            a {
                width: 100%;
                span {
                    width: 100%;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                            margin: 0;
                        `,
                        css`
                            width: 100%;
                            margin: 0;
                        `,
                        css`
                            width: 100%;
                            margin: 0;
                        `,
                        css`
                            padding-top: 10px;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: auto;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            height: 50px;
                            width: auto;
                            margin: 0;
                        `,
                        css`
                            height: 50px;
                            width: auto;
                            margin: 0;
                        `,
                        css`
                            height: 50px;
                            width: auto;
                            margin: 0;
                        `,
                        null,
                        null,
                    ]);
                }}
            }
        `,
    },
    searchWrapperSticky: {
        css: css`
            width: 43%;
            margin-left: 3%;
            display: flex;
            justify-content: center;
            align-items: center;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 94%;
                            padding: 3px 0 15px;
                        `,
                        css`
                            width: 94%;
                            padding: 3px 0 15px;
                        `,
                        css`
                            width: 94%;
                            padding: 3px 0 15px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            > div[class^="HiddenStyle"] {
                width: 100%;
                > div[class^="Wrapper"] {
                    border: ${getColor("text.accent")} 1px solid;
                    border-radius: 20px;
                    height: 40px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    border-color: #e2e2e2;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        );
                    }}
                    input,
                    button {
                        border-radius: 20px !important;
                    }
                    [class^="FormFieldStyle"] {
                        width: 100%;
                        input {
                            background: #f8f8f8;
                            ::placeholder {
                                font-size: 12px;
                                opacity: 1; /* Firefox */
                            }
                            :-ms-input-placeholder {
                                /* Internet Explorer 10-11 */
                                font-size: 12px;
                            }
                            ::-ms-input-placeholder {
                                /* Microsoft Edge */
                                font-size: 12px;
                            }
                        }
                        & + div[id^="headerSearch"] {
                            margin-top: 2px;
                            min-width: 40%;
                            input,
                            button {
                                border-radius: 0 !important;
                            }
                        }
                    }
                    div[class^="PopoverStyle"] {
                        // right: 10px !important;
                        a,
                        button,
                        span {
                            color: ${getColor("text.main")};
                            font-size: 13px;
                        }
                        [class^="StyledButton"] {
                            font-weight: 600;
                        }
                    }
                }
            }
        `,
    },
    phoneNumberWrapperSticky: {
        css: css`
            display: flex;
            align-items: center;
            width: 15%;
            margin-left: 3%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            width: 20%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
            p.phoneNumber {
                border: 1px solid #ccc;
                border-radius: 20px;
                height: 40px;
                display: flex;
                align-items: center;
                width: 100%;
                justify-content: center;
                a{
                    font-size: 13px;
                    height: auto;
                }
                    span[class^="TypographyStyle"] {
                        display: flex;
                        align-items: flex-start;
                        color: ${getColor("text.accent")};
                        span {
                            height: 18px;
                            span[class^="LazyImageStyle"] {
                                img {
                                    width: 18px;
                                    height: 18px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    searchMenuWrapperSticky: {
        css: css`
            text-align: right;
            padding: 0 15px 0 20px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            > div {
                > div {
                    display: flex;
                    flex-direction: row;
                    align-items: start;
                    position: relative;
                }
                button,
                a,
                .trigger {
                    display: flex;
                    flex-direction: column;
                    margin: 0 15px;
                    height: auto;
                    span[class^="StyledButton"] {
                        span[class^="TypographyStyle"] {
                            display: none;
                        }
                    }
                    span[class^="IconWrapper"] + span[class^="TypographyStyle"] {
                        display: none;
                    }

                    span[class^="IconWrapper"],
                    span[class^="LazyImageStyle"] {
                        background: ${getColor("text.accent")};
                        padding: 10px;
                        border-radius: 20px;
                        width: 40px;
                        height: 40px;
                        margin: 0;
                        svg {
                            color: #fff;
                            width: 20px;
                            height: 20px;
                        }
                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }
                    p {
                        display: none;
                    }
                    &:hover {
                        span,
                        p {
                            text-decoration: underline;
                        }
                    }
                }
            }
            a[data-test-selector="cartLink"] {
                span[class^="HiddenStyle"] {
                    display: none;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            div[data-test-selector="Greetings"] {
                display: none;
            }
        `,
    },
    mobileCartWrapper: {
        css: css`
            display: none;
            position: absolute;
            right: 15px;
            top: 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: flex;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            span[class^="IconWrapper"] {
                background: ${getColor("text.accent")};
                padding: 10px;
                border-radius: 20px;
                width: 40px;
                height: 40px;
                margin: 0;
                svg {
                    color: #fff;
                }
            }
        `,
    },
    mobileCartWrapperSticky: {
        css: css`
            display: none;
            position: absolute;
            right: 15px;
            top: 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: flex;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            span[class^="IconWrapper"] {
                background: ${getColor("text.accent")};
                padding: 10px;
                border-radius: 20px;
                width: 40px;
                height: 40px;
                margin: 0;
                svg {
                    color: #fff;
                }
            }
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => {
    const [isSticky, setIsSticky] = useState(false);
    const checkResolution = () => {
        const physicalScreenHeight = screen.height * window.devicePixelRatio;
        if (physicalScreenHeight <= 768) {
            const mainDiv = document.querySelector<HTMLElement>(`main`);
            if (mainDiv) {
                mainDiv.style.minHeight = "600px";
            }
        }
    };

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;

        const handleScroll = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                const y = window.pageYOffset;
                setIsSticky(prev => {
                    if (!prev && y > 130) {
                        return true;
                    }
                    if (prev && y < 90) {
                        return false;
                    }
                    return prev;
                });
            }, 50);
        };

        window.addEventListener("scroll", handleScroll);
        checkResolution();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            clearTimeout(timer);
        };
    }, []);

    return (
        <>
            <StyledWrapper {...(isSticky ? { ...logoLinksSearchStyles.scrollFixed } : "")}>
                <StyledWrapper {...logoLinksSearchStyles.container}>
                    <StyledWrapper
                        {...logoLinksSearchStyles.logoWrapper}
                        {...(isSticky ? { ...logoLinksSearchStyles.logoWrapperSticky } : "")}
                    >
                        <Zone contentId={id} zoneName="Logo" />
                    </StyledWrapper>
                    <Hidden below="lg" {...logoLinksSearchStyles.alignMiddle}>
                        <StyledWrapper
                            {...logoLinksSearchStyles.stickProductsWrapper}
                            {...(isSticky ? { ...logoLinksSearchStyles.stickProductsWrapperVisible } : "")}
                        >
                            <Hidden>
                                <Zone contentId={id} zoneName="productMenuSticky" />
                            </Hidden>
                        </StyledWrapper>
                    </Hidden>

                    <StyledWrapper
                        {...logoLinksSearchStyles.mobileCartWrapper}
                        {...(isSticky ? { ...logoLinksSearchStyles.mobileCartWrapperSticky } : "")}
                    >
                        <Zone contentId={id} zoneName="MobileCart" />
                    </StyledWrapper>
                    <StyledWrapper
                        {...logoLinksSearchStyles.searchWrapper}
                        {...(isSticky ? { ...logoLinksSearchStyles.searchWrapperSticky } : "")}
                    >
                        <Hidden>
                            <Zone contentId={id} zoneName="Search" />
                        </Hidden>
                    </StyledWrapper>
                    <StyledWrapper
                        {...logoLinksSearchStyles.phoneNumberWrapper}
                        {...(isSticky ? { ...logoLinksSearchStyles.phoneNumberWrapperSticky } : "")}
                    >
                        <Hidden {...logoLinksSearchStyles.phoneNumber}>
                            <Zone contentId={id} zoneName="phoneNumber" />
                        </Hidden>
                    </StyledWrapper>
                    <StyledWrapper
                        {...logoLinksSearchStyles.searchMenuWrapper}
                        {...(isSticky ? { ...logoLinksSearchStyles.searchMenuWrapperSticky } : "")}
                    >
                        <Hidden {...logoLinksSearchStyles.linkListHidden}>
                            <Zone contentId={id} zoneName="Greetings" />
                            <Zone contentId={id} zoneName="LinkList" />
                        </Hidden>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
        isSystem: true,
    },
};

export default logoLinksSearch;
